import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export const firewallDescription: Translatable = (
    <Trans>
        Rules from all attached firewalls are combined, a connection is allowed if there is at least one rule that
        allows it.
    </Trans>
);
export const firewallInboundDescription: Translatable = (
    <Trans>
        Incoming traffic is allowed only to the specified ports if it originates from the specified sources. All other
        traffic will be blocked.
    </Trans>
);
export const firewallOutboundDescription: Translatable = (
    <Trans>
        Outgoing traffic is allowed only to the specified ports of the specified destinations. All other traffic will be
        blocked.
    </Trans>
);

export const allIpAddressesLabel: Translatable = (
    <Trans comment="A firewall rule that applies to every source or destination IP address">All IP addresses</Trans>
);
export const ipAddressOrCidrRangePlaceholder = msg`IP address or CIDR range`;
export const startPortLabel: Translatable = <Trans>Start port</Trans>;
export const endPortLabel: Translatable = <Trans>End port</Trans>;
